import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SupportComponent } from './support/support.component';
const routes: Routes = [
  { path: 'privacypolicy', component: PrivacyPolicyComponent },
   { path: 'support', component: SupportComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrivacyRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/privacy/privacy-routing.module.ts